import { render } from "./TermsOfServices.vue?vue&type=template&id=f6331452"
import script from "./TermsOfServices.vue?vue&type=script&lang=js"
export * from "./TermsOfServices.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/helpdesk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__